/**
 * @ngdoc component
 * @name westBerkshireEvents.terms:wbTerms
 * 
 * @description 
 * This component uses a template to display the terms and conditions modal
 */

import termsTemplate from './terms.template.html';
import termsHeritageTemplate from './terms_heritage.template.html';
import termsFamilyHubsTemplate from './terms_family_hubs.template.html';

angular.module('westBerkshireEvents.terms').component('wbTerms', {
    templateUrl: termsTemplate.id,
    controller: ['$scope', 'ModalForm', '$uibModal', wbTermsController],
    controllerAs: "$termsCtrl",
    bindings: {
        journey: '<'
    }
});

function wbTermsController($scope, ModalForm, $uibModal) {
    let self = this;

    self.showTerms = function () {
        if (this.journey == "heritage_events") {
            return $uibModal.open({
                templateUrl: termsHeritageTemplate.id,
                windowClass: "wb-modal-window"
            });
        } else if(this.journey == "family_hubs_events" || this.journey == "all_events"){
            return $uibModal.open({
                templateUrl: termsFamilyHubsTemplate.id,
                windowClass: "wb-modal-window"
            });
        }
    };
}


// WEBPACK FOOTER //
// src/public/javascripts/terms/terms.component.js